/* eslint-disable @typescript-eslint/no-explicit-any */
import { Panel } from '@/bc'
import {
  DeleteIcon,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Button,
  DialogClose,
  Input,
  ZyshuaxinIcon,
} from '@/component'
import React from 'react'
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-react'
type ParamFiltersVo = {
  id?: number
  filterType?: string
  filterName?: string
  filterContent?: string
  [prop: string]: any
}
/** @deprecated 请使用 FilterSummaryProvider 组件替代 */
const Root = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <Panel.Root className={cn('py-4 rounded-none rounded-t-xl', className)}>
      <Panel.Content className="px-0">{children}</Panel.Content>
    </Panel.Root>
  )
}
/** @deprecated 请使用 FilterSummaryProvider 组件替代 */
const Content = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div className="flex gap-x-2.5 px-4 ">
      <div className={cn('flex w-full flex-wrap gap-2', className)}>{children}</div>
    </div>
  )
}

/** @deprecated 请使用 SelectedFiltersSummary 组件替代 */
const Result = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="bg-background rounded-b-xl flex items-center justify-between gap-2 overflow-hidden p-4 shadow-[inset_0_1px_0_0] shadow-shadow">
      {children}
    </div>
  )
}

const Saved = ({
  data,
  onSelected,
  onDelete,
}: {
  data?: ParamFiltersVo[]
  onSelected?: (params: object) => void
  onDelete?: (item?: ParamFiltersVo) => void
}) => {
  const [open, setOpen] = React.useState(false)
  const [selected, setSelected] = React.useState<ParamFiltersVo>()
  const [willDeleted, setWillDeleted] = React.useState<ParamFiltersVo>()
  const [dialogOpen, setDialogOpen] = React.useState(false)

  return (
    <>
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger className="flex h-8 w-max max-w-40 shrink-0 items-center justify-center gap-2 focus-visible:outline-none">
          <div className="line-clamp-1 break-all">
            {selected ? selected.filterName : <span className="text-sm ">快速筛选项</span>}
          </div>
          <ChevronDown size={16} className={cn('shrink-0', open && 'rotate-180')} />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-80">
          {data?.length ? (
            data.map((m) => (
              <DropdownMenuItem
                key={m.id}
                onClick={() => {
                  setSelected(m)
                  onSelected?.(JSON.parse(m.filterContent || '{}'))
                  setOpen(false)
                }}
              >
                <div className="line-clamp-1 break-all" title={m.filterName}>
                  {m.filterName}
                </div>
                <div className="flex-1" />
                <button
                  onClick={(ev) => {
                    ev.stopPropagation()
                    setWillDeleted(m)
                    setDialogOpen(true)
                  }}
                >
                  <DeleteIcon size={11} />
                </button>
              </DropdownMenuItem>
            ))
          ) : (
            <div className="py-6 text-center text-sm">暂无数据</div>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              <span>删除</span>
            </DialogTitle>
          </DialogHeader>
          <div className="px-5">Are you sure you want to delete this filter?</div>
          <DialogFooter>
            <DialogClose>
              <div className="flex gap-2">
                <Button variant="outline">取消</Button>
                <Button
                  onClick={() => {
                    if (willDeleted?.id === selected?.id) {
                      setSelected(undefined)
                    }
                    onDelete?.(willDeleted)
                    setOpen(false)
                  }}
                >
                  确定
                </Button>
              </div>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
const ClearButton = ({ onClear }: { onClear: () => void }) => {
  return (
    <Button type="button" variant="ghost" onClick={onClear} className="text-foreground cursor-pointer">
      <ZyshuaxinIcon />
      <span>清空选项</span>
    </Button>
  )
}
const SaveButton = ({
  children,
  onSave,
  disabled,
}: {
  disabled?: boolean
  children?: React.ReactNode
  onSave?: (filterName: string) => void
}) => {
  const [open, setOpen] = React.useState(false)
  const [filterName, setFilterName] = React.useState<string>('')
  return (
    <>
      <Button
        variant="link"
        disabled={disabled}
        className="px-0"
        onClick={() => {
          setFilterName('')
          setOpen(true)
        }}
      >
        {children || '保存选项'}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              <span>保存</span>
            </DialogTitle>
          </DialogHeader>
          <div className="px-5">
            <Input allowClear placeholder={'请输入'} value={filterName} onValueChange={setFilterName} maxLength={50}></Input>
          </div>
          <DialogFooter>
            <DialogClose>
              <div className="flex gap-2">
                <Button variant="outline">取消</Button>
                <Button onClick={() => onSave?.(filterName)}>确定</Button>
              </div>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
const ApplyButton = ({ apply, children }: { apply: () => void; children?: React.ReactNode }) => {
  return <button onClick={apply}>{children || <span className=" text-accent ">确定</span>}</button>
}

export { Root, Content, Result, Saved, ClearButton, SaveButton, ApplyButton }
